import React from 'react';
import { useBemCN } from '@gik/core/utils/bemBlock';

const blockName = 'container';

export interface ContainerProps {
  className?: string;
  element?: string;
}

export default function Container({ children, className, element = 'div' }: React.PropsWithChildren<ContainerProps>) {
  const bem = useBemCN(blockName);

  return React.createElement(
    element,
    {
      ...bem(null, null, [className]),
    },
    children
  );
}
